import JobService from '../services/job.services';
import { Job, JobSummary, JobDetailed } from '../types/Job';
import JobMapper, { JOB_MAP_OPERATION } from '../mappers/job.mapper';
import { Metadata } from '../utils/HttpClientHandler';

const JobController = class JobController {
    public async getAllJobs(
        // eslint-disable-next-line default-param-last
        filters = {},
        mapOperation?: JOB_MAP_OPERATION,
    ): Promise<{ jobs: Job[] | JobSummary[]; _metadata: Metadata }> {
        const { data: jobs, _metadata }: { data: Job[]; _metadata: any } = await JobService.getAllJobs(filters);
        return !mapOperation ? { jobs, _metadata } : { jobs: JobMapper[mapOperation](jobs), _metadata };
    }

    public async getJobById(jobId: number | string, mapOperation?: JOB_MAP_OPERATION): Promise<Job | JobDetailed> {
        const job: Job = await JobService.getJobById(Number(jobId));
        return !mapOperation ? job : JobMapper[mapOperation](job);
    }

    public async releaseJob(jobId: number | string, mapOperation?: JOB_MAP_OPERATION): Promise<Job | JobDetailed> {
        const job: Job = await JobService.releaseJob(Number(jobId));
        return !mapOperation ? job : JobMapper[mapOperation](job);
    }
};

export default new JobController();
